import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import * as cnst from '@ts/const';
import ImgPictures from '@components/img-pictures';
const SaleHeader = ({ saleProp, saleItemListDisplay }) => {
    const [className, setClassName] = useState('a-sale-header');
    const handleClick = useCallback(() => {
        // セールがすでに終了している場合は開閉機能を有効にする
        if (saleProp.sale_status === 2) {
            saleItemListDisplay('toggle');
        }
    }, [
        saleProp
    ]);
    useEffect(() => {
        if (saleProp.sale_status === 2) {
            setClassName(classNames('a-sale-header', 'cursor-pointer'));
        }
    }, [
        saleProp
    ]);
    return (React.createElement("div", { onClick: () => handleClick(), className: className },
        React.createElement("div", { className: "base-width sm:gutter" },
            saleProp.sale_status === 1 && /** セール中 */
                /* <ImgPicture fileName={ `./assets/img/head/${saleProp.img_header}` } /> */
                React.createElement(ImgPictures, { fileNameLarge: `./assets/img/head/${saleProp.img_header}-md`, fileNameSmall: `./assets/img/head/${saleProp.img_header}-sm`, mediaQueryLarge: cnst.MEDIA_QUERY_LARGE, mediaQuerySmall: cnst.MEDIA_QUERY_SMALL }),
            saleProp.sale_status === 2 && /** セール終了 */
                /* <ImgPicture fileName={ `./assets/img/head/${saleProp.img_header_eos}` } /> */
                React.createElement(ImgPictures, { fileNameLarge: `./assets/img/head/${saleProp.img_header_eos}-md`, fileNameSmall: `./assets/img/head/${saleProp.img_header_eos}-sm`, mediaQueryLarge: cnst.MEDIA_QUERY_LARGE, mediaQuerySmall: cnst.MEDIA_QUERY_SMALL }),
            saleProp.sale_status === 0 && /** セール前 */
                /* <ImgPicture fileName={ `./assets/img/head/${saleProp.img_header_eos}` } /> */
                React.createElement(ImgPictures, { fileNameLarge: `./assets/img/head/${saleProp.img_header_pre}-md`, fileNameSmall: `./assets/img/head/${saleProp.img_header_pre}-sm`, mediaQueryLarge: cnst.MEDIA_QUERY_LARGE, mediaQuerySmall: cnst.MEDIA_QUERY_SMALL }))));
};
export default SaleHeader;
